import React, { useMemo } from 'react';

import { useAppStore } from 'hooks/common/useAppStore';

import { getImageUrl } from './utils';

export interface Props {
  alt: string;
  src: string;
  additionalParam?: string;
  className?: string;
  fallbackImage?: string;
}

function Img({ src, additionalParam = '', alt, className, fallbackImage }: Props) {
  const { appStore } = useAppStore();
  const staticAssetsUrl = appStore.staticAssetsUrl || '';

  const image = useMemo(
    () =>
      getImageUrl({
        src,
        staticAssetsUrl,
        additionalParam,
        fallbackImage,
      }),
    [src, staticAssetsUrl, additionalParam, fallbackImage],
  );

  return <img alt={alt} className={className} src={image} />;
}

export default React.memo(Img);
